import { rentalBeastApi } from "api/rentalBeast";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedAutoAddCard } from "views/settings-integration/integrations/shared/FeedAutoAddCard";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const RentalBeastView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectRentalBeast, isPending: isDisconnecting } =
    useMutation({
      mutationKey: ["RENTAL_BEAST", "DELETE"],
      mutationFn: () => rentalBeastApi.disconnect(),
      onSuccess: () => {
        toast.success("Rental Beast integration disconnected successfully");
        refreshPartnerData();
        navigate("/settings/integration");
      },
      onError: (err) => {
        toast.error(getErrorMessage(err));
      }
    });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.RENTAL_BEAST}
          name="Rental Beast"
          path="/settings/integration/rental-beast"
          onDisconnect={() => disconnectRentalBeast()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <div className="space-y-6">
        <FeedAutoAddCard feed="rental_beast" feedLabel="Rental Beast" />
        <FeedListingsCard feed="rental_beast" feedLabel="Rental Beast" />
      </div>
    </Layout>
  );
};
